import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/blackred.png';
import { CardMedia } from '@mui/material';

const topbarLink = {
    cursor: 'pointer',
    color: '#616161',
    fontSize: 23,
    mr: 2,
    border: 1,
    padding: 1
} as const;

interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
}

const drawerWidth = 180;
const navItems: any = [];
navItems[0] = 'Lookup'
navItems[1] = 'Activation';

const NavBar = (props: Props) => {
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);

    let history = useNavigate();

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <CardMedia
                component="img"
                sx={{ width: 160 }}
                image={logo}
                alt="T1A Logo"
                onClick={() => history('/')}
            />
            <Divider />
            <List>
                {/* {navItems.map((item) => ( */}
                <ListItem disablePadding>
                    <ListItemButton>
                        <ListItemText onClick={() => history('/lookup')} primary={navItems[0]} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton>
                        <ListItemText onClick={() => history('/activation')} primary={navItems[1]} />
                    </ListItemButton>
                </ListItem>
                {/* ))} */}
            </List>
        </Box>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box
            sx={{ display: 'flex',
                '& .MuiPaper-root': {
                    maxWidth: 1920,
                    
                }
            }}
            >
            <AppBar component="nav" sx={{bgcolor:'white', p:2 }} position="static">
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' }, color:'black' }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
                    >
                        <CardMedia
                            component="img"
                            sx={{ width: 160 }}
                            image={logo}
                            alt="T1A Logo"
                            onClick={() => history('/')}
                        />
                    </Typography>
                    <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                        {/* {navItems.map((item) => ( */}
                        <Button sx={topbarLink} onClick={() => history('/lookup')}>
                            {navItems[0]}
                        </Button>
                        <Button sx={topbarLink} onClick={() => history('/activation')}>
                            {navItems[1]}
                        </Button>
                        {/* ))} */}
                    </Box>
                </Toolbar>
            </AppBar>
            <Box component="nav">
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
            </Box>
            <Box component="main" sx={{ p: 3 }}>
                <Toolbar />
            </Box>
        </Box>
    );
}
export default NavBar;